// extracted by mini-css-extract-plugin
export var main = "about-module--main--7cZs0";